import { render, staticRenderFns } from "./TableStatistics.vue?vue&type=template&id=39afe1f3"
import script from "./TableStatistics.vue?vue&type=script&lang=js"
export * from "./TableStatistics.vue?vue&type=script&lang=js"
import style0 from "./TableStatistics.vue?vue&type=style&index=0&id=39afe1f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports